import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaireItemSautDeLigneClass} from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';

interface IPageAe0003 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Ae0003Controller(Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPageAe0003 = this;

    vm.multiOccurrenceOptions = {
        filtresParametres: [
            {colonne: 'stamnetab', valeur:'TEM', visible: false}
        ],
        colonnesVisibles: [
            {nom: 'temcod', largeur: 90},
            {nom: 'temdscabr', largeur: 245},
            {nom: 'rgecod', largeur: 120},
            {nom: 'rgedsc', largeur: 220},
            {nom: 'rgecodpro', largeur: 120},
            {nom: 'rgedscpro', largeur: 245},
            {nom: 'vaccod', largeur: 110},
            {nom: 'vacdsc', largeur: 202}
        ],
        colonnesCachees: ['stamnetab'],
        formulaire: new Formulaire([
            new FormulaireItem('ipacleintref', {largeur: 60}),
            new FormulaireItem('vacsyszonrec' , {largeur: 30}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('rgecleint', {largeur: 40}  ),
            new FormulaireItem('rgecleintpro', {largeur: 40})
        ]),
        fonctions: {
            importation: true
        }
    };
}
